import { Component, HostBinding, Input } from '@angular/core';
import { ThemeProviderService } from 'src/app/shared/services/theme-provider.service';

@Component({
  selector: 'studio-popup-menu-group',
  templateUrl: './popup-menu-group.component.html',
  styleUrls: ['./popup-menu-group.component.scss'],
})
export class PopupMenuGroupComponent {
  @Input() heading: string;

  @HostBinding('class')
  protected get theme() {
    return this.themeProviderService.getTheme();
  }

  constructor(private themeProviderService: ThemeProviderService) {}
}
